import React from "react";
import { string, object } from "prop-types";
import "./hero-title.m.css";

export const HeroTitle = ({ children, className, style }) => {
  return (
    <div styleName="hero-title" className={className} style={style}>
      {children}
    </div>
  );
};

HeroTitle.propTypes = {
  children: string.isRequired,
  className: string,
  style: object,
};